import {SwiperConfigInterface} from 'ngx-swiper-wrapper';

export const SwiperConfiguration: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1.1,
    centeredSlides: false,
    spaceBetween: 10
};
